<template>
    <div class="row">
        <div class="col mb-3">
            <div class="mb-1 d-block">
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="type" id="bulan" v-model="type" value="bulan">
                    <label class="form-check-label" for="bulan">Bulan</label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="type" id="tarikh" v-model="type" value="tarikh">
                    <label class="form-check-label" for="tarikh">Tarikh</label>
                </div>
            </div>
            <div class="d-flex flex-wrap justify-content-between" v-if="type ==='tarikh'">
                    <VueDatePicker v-model="dateFrom" :auto-position="true"
                                   :time-config="{ enableTimePicker: false }" :formats="{ input: 'dd-MMM-yyyy', preview: 'dd-MMM-yyyy' }" week-start="0" :locale="ms" :format-locale="ms"
                                   placeholder="Tarikh mula" select-text="Pilih" cancel-text="Tutup" required class="d-inline-block me-2" style="max-width: 250px"></VueDatePicker>
                    <span class="d-inline-block me-2 my-1">hingga</span>
                    <VueDatePicker v-model="dateTo" :auto-position="true"
                                   :time-config="{ enableTimePicker: false }" :formats="{ input: 'dd-MMM-yyyy', preview: 'dd-MMM-yyyy' }" week-start="0" :locale="ms" :format-locale="ms"
                                   placeholder="Tarikh akhir" select-text="Pilih" cancel-text="Tutup" required class="d-inline-block" style="max-width: 250px"></VueDatePicker>
                    <div class="d-inline-block mx-2 flex-grow-0">
                        <label for="bilProjekTarikh" class="form-label d-inline-block me-2">Bilangan projek</label>
                        <select id="bilProjekTarikh" class="form-select d-inline-block" style="width: 100px" v-model="columnPerProjectSelected">
                            <option v-for="col in columnPerProject" :value="col" class="text-center">{{ col }}</option>
                        </select>
                    </div>
                    <button :disabled="(dateFrom ===  null && dateTo === null)"
                            type="button" class="btn btn-primary ms-2" @click="getData()"><font-awesome-icon :icon="faMagnifyingGlass" class="me-2 flex-grow-0"/>Cari
                    </button>
                    <div class="form-check form-check-inline ms-2 flex-grow-0 position-relative" style="top: 5px">
                        <input class="form-check-input" type="checkbox" id="pejabatLamaTarikh" value="old" v-model="olderOffice">
                        <label class="form-check-label" for="pejabatLamaTarikh">Kaunter lama</label>
                    </div>
                    <form v-if="reportData.length > 0" :action="uri_download_projek_kaunter_ringkasan" method="post" class="d-inline-block flex-grow-0">
                        <input type="hidden" name="_token" :value="csrf">
                        <input type="hidden" v-if="olderOffice !== undefined" name="wantOld" :value="(olderOffice)?1:0">
                        <input type="hidden" v-if="type === 'tarikh' && dateFrom !== null" name="from" :value="parseDateData(dateFrom)">
                        <input type="hidden" v-if="type === 'tarikh' && dateTo !== null" name="to" :value="parseDateData(dateTo)">
                        <input type="hidden" name="numberProjects" :value="columnPerProjectSelected">
                        <button type="submit" :disabled="(dateFrom ===  null && dateTo === null) && type === 'tarikh'" class="btn btn-outline-success fs-6 d-inline-block" ><font-awesome-icon :icon="faFileExcel" class="me-2" />Muat turun laporan</button>
                    </form>
                    <div class="flex-grow-1">
                        <button type="button" class="btn btn-warning ms-2 float-end "
                                @click="goBack">
                            <font-awesome-icon :icon="faChevronLeft" /> Kembali
                        </button>
                    </div>
                </div>
            <div class="d-flex flex-wrap justify-content-between" v-if="type ==='bulan'">
                <select class="form-select flex-grow-0" style="width: 100px" v-model="monthSelected">
                    <option v-for="m in monthRange" :value="m" class="text-center">{{ m }}</option>
                </select>
                <select class="form-select flex-grow-0" style="width: 100px" v-model="yearSelected">
                    <option v-for="y in yearRange" :value="y" class="text-center">{{ y }}</option>
                </select>
                <div class="flex-grow-0 mx-2">
                    <label for="bilProjekBulan" class="form-label flex-grow-0 me-2">Bilangan projek</label>
                    <select id="bilProjekBulan" class="form-select d-inline-block" style="width: 100px" v-model="columnPerProjectSelected">
                        <option v-for="col in columnPerProject" :value="col" class="text-center">{{ col }}</option>
                    </select>
                </div>
                <button  type="button" class="btn btn-primary ms-2" @click="getData()"><font-awesome-icon :icon="faMagnifyingGlass" class="me-2"/>Cari</button>
                <div class="form-check form-check-inline ms-2 flex-grow-0 position-relative" style="top: 5px">
                    <input class="form-check-input" type="checkbox" id="pejabatLamaBulan" value="old" v-model="olderOffice">
                    <label class="form-check-label" for="pejabatLamaBulan">Kaunter lama</label>
                </div>
                <form v-if="reportData.length > 0" :action="uri_download_projek_kaunter_ringkasan" method="post" class="d-inline-block">
                    <input type="hidden" name="_token" :value="csrf">
                    <input type="hidden" v-if="olderOffice !== undefined" name="wantOld" :value="(olderOffice)?1:0">
                    <input type="hidden" v-if="type === 'bulan'" name="month" :value="monthSelected">
                    <input type="hidden" v-if="type === 'bulan'" name="year" :value="yearSelected">
                    <input type="hidden" name="numberProjects" :value="columnPerProjectSelected">
                    <button type="submit" class="btn btn-outline-success fs-6 d-inline-block" ><font-awesome-icon :icon="faFileExcel" class="me-2" />Muat turun laporan</button>
                </form>
                <div class="flex-grow-1">
                    <button type="button" class="btn btn-warning ms-2 float-end "
                            @click="goBack">
                        <font-awesome-icon :icon="faChevronLeft" /> Kembali
                    </button>
                </div>
            </div>

        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <div class="d-flex justify-content-center align-self-center flex-wrap ">
                <template v-if="reportData.length > 0">
                    <template v-for="(rd,indexer) in reportData" :key="rd">
                        <div class="tblPro table-responsive p-2">
                        <table class="table table-striped-columns mb-5" style="width: 890px; height: 1700px">
                            <thead class="table-dark">
                            <tr>
                                <th class="text-center align-middle" style="width: 5px;" rowspan="3">Bil</th>
                                <th class="text-center align-middle" rowspan="3">Kaunter</th>
                                <th class="text-center" :colspan="reportData[indexer].projects.length*2">Projek</th>
                                <th v-if="indexer === reportData.length - 1" class="table-success text-center align-middle" colspan="2" rowspan="2">Jumlah</th>
                            </tr>
                            <tr>
                                <th colspan="2" v-for="project in reportData[indexer].projects" class="text-center position-sticky text-break align-middle" style="border: 1px solid black; top: 0; width: 200px;">{{ project }}</th>
                            </tr>
                            <tr>
                                <template v-for="n in reportData[indexer].projects.length" :key="n">
                                    <th class="text-center position-sticky" style="border: 1px solid black;" :style="{ 'top': offsetHeight + 'px' }">Bil</th>
                                    <th class="text-center position-sticky" style="border: 1px solid black;" :style="{ 'top': offsetHeight + 'px' }">Amaun</th>
                                </template>
                                <th v-if="indexer === reportData.length - 1" class="table-success text-center position-sticky" style="border: 1px solid black;" :style="{ 'top': offsetHeight + 'px' }">Bil</th>
                                <th v-if="indexer === reportData.length - 1" class="table-success text-center position-sticky" style="border: 1px solid black;" :style="{ 'top': offsetHeight + 'px' }">Amaun</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(item,index) in reportData[indexer].ringkasanProjekWakafKaunter" :key="index">
                                <template v-for="(itemm,indexx) in item" :key="indexx">
                                    <td v-if="indexx === 0 && String(item[1]).startsWith('Zon')" class="border-right-0" style="background: #0a58ca"></td>
                                    <td v-else-if="indexx === 0 && typeof item[indexx] === 'number'" class="text-white fw-bold">{{ item[0] }}</td>
                                    <td v-else-if="indexx === 1 && typeof item[indexx] === 'number'" class="text-white fw-bold">{{ item[1] }}</td>
                                    <td v-else-if="indexx === 1 && String(item[1]).startsWith('Zon')" style="background: #0a58ca" class="text-white fw-bold">{{ item[1] }}</td>
                                    <td v-else-if="indexx === 1 " class="text-white fw-bold">{{ item[1] }}</td>
                                    <td v-else-if="indexx < item.length - 2 && indexx % 2 !== 0 && String(item[1]).startsWith('Zon')" style="background: #0a58ca" class="text-white text-end">{{ sumFormatWithoutCurrency(Number(item[indexx])) }}</td>
                                    <td v-else-if="indexx < item.length - 2 && indexx % 2 !== 0" class="text-end">{{ sumFormatWithoutCurrency(Number(item[indexx])) }}</td>
                                    <td v-else-if="indexx < item.length - 2 && indexx % 2 === 0 && String(item[1]).startsWith('Zon')" style="background: #0a58ca" class="text-white text-end">{{ sumFormatWithoutDecimal(Number(item[indexx])) }}</td>
                                    <td v-else-if="indexx < item.length - 2 && indexx % 2 === 0" class="text-end">{{ sumFormatWithoutDecimal(Number(item[indexx])) }}</td>
                                    <td v-else-if="indexx < item.length && indexx % 2 !== 0  && String(item[1]).startsWith('Zon')" style="background: #0a58ca" class="text-white fw-bold text-end">{{ sumFormatWithoutCurrency(Number(item[indexx])) }}</td>
                                    <td v-else-if="indexx < item.length && indexx % 2 !== 0 && indexer === reportData.length-1" class="table-success fw-bold text-end">{{ sumFormatWithoutCurrency(Number(item[indexx])) }}</td>
                                    <td v-else-if="indexx < item.length && indexx % 2 !== 0" class="text-end">{{ sumFormatWithoutCurrency(Number(item[indexx])) }}</td>
                                    <td v-else-if="indexx < item.length && indexx % 2 === 0 && String(item[1]).startsWith('Zon')" style="background: #0a58ca" class="text-white fw-bold text-end">{{ sumFormatWithoutDecimal(Number(item[indexx])) }}</td>
                                    <td v-else-if="indexx < item.length && indexx % 2 === 0 && indexer === reportData.length-1" class="table-success fw-bold text-end">{{ sumFormatWithoutDecimal(Number(item[indexx])) }}</td>
                                    <td v-else-if="indexx < item.length && indexx % 2 === 0" class="text-end">{{ sumFormatWithoutDecimal(Number(item[indexx])) }}</td>
                                </template>
                            </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                <td class="border-right-0"></td>
                                <td class="text-center fw-bold text-white">Jumlah</td>
                                <td v-for="(grandSumInQue,index) in reportData[indexer].bills" class="table-dark fw-bold text-end">{{ (index%2 === 0)? sumFormatWithoutDecimal(grandSumInQue) : sumFormatWithoutCurrency(grandSumInQue) }}</td>
                                <td v-if="indexer === reportData.length - 1" class="table-dark fw-bold text-end">{{ sumFormatWithoutDecimal(reportData[indexer].grandSumBilTotal) }}</td>
                                <td v-if="indexer === reportData.length - 1" class="table-dark fw-bold text-end">{{ sumFormatWithoutCurrency(reportData[indexer].grandSumAmaunTotal) }}</td>
                            </tr>
                            </tfoot>
                        </table>
                        </div>
                    </template>
                </template>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import {nextTick, onMounted, Ref, ref} from "vue";
import {arrayMonth, arrayYear, sumFormatWithoutCurrency, sumFormatWithoutDecimal, parseDateData} from "../../utils/utils";
import axios, {AxiosError} from "axios";
import Swal from "sweetalert2";
import { VueDatePicker } from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css"
import { ms } from "date-fns/locale"
import { formatISO } from "date-fns"
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {faChevronLeft, faFileExcel, faMagnifyingGlass} from "@fortawesome/free-solid-svg-icons";
import number = CSS.number;
library.add(faChevronLeft);
library.add(faFileExcel);
library.add(faMagnifyingGlass);

const data = defineProps<{
    uri_get_projek_kaunter_ringkasan: string,
    uri_download_projek_kaunter_ringkasan: string,
    month: number,
    year: number,
    csrf: string,
}>();

const type: Ref = ref<string>("bulan");
const columnPerProject: Ref = ref<number[]>([4,5,6,7,8]);
const columnPerProjectSelected: Ref = ref<number>(4);
const yearRange: Ref = ref<number[]>();
const monthRange: Ref = ref<number[]>();
const dateFrom: Ref = ref<string|null>(null);
const dateTo: Ref = ref<string|null>(null);
const yearSelected: Ref = ref<number>();
const monthSelected: Ref = ref<number>();
const reportData: Ref = ref<{
    bills: number[],
    projects: string[],
    grandSumBilTotal: number,
    grandSumAmaunTotal: number,
    ringkasanProjekWakafKaunter: (string|number)[][]
}[]>([]);

const olderOffice = ref<boolean>(false);
const offsetHeight = ref<number>(0);

const emitToParent = defineEmits<{
    (e: "hidePage", flag: boolean): void,
    (e: "hideLoader"): void,
    (e: "showLoader"): void,
}>();

onMounted(() => {
    setTimeout(()=> {
        yearRange.value = arrayYear(data.year);
        monthRange.value = arrayMonth();
        monthSelected.value = data.month;
        yearSelected.value = data.year;
        getData();
    },1000);
});

const getData = () => {
    emitToParent("showLoader");
    let postData: {
        csrf: string,
        numberProjects: number,
        month?: number,
        year?: number,
        from?: string,
        to?: string,
        wantOld?: number
    } = {
        numberProjects: columnPerProjectSelected.value,
        csrf: data.csrf
    };
    if (olderOffice.value === true) {
        postData = { ... postData, wantOld: 1} ;
    }
    if (type.value === "bulan") {
        postData = { ... postData, month: monthSelected.value};
        postData = { ... postData, year: yearSelected.value};
    } else if (type.value === "tarikh") {
        if (dateFrom.value !== null) {
            postData = { ... postData, from: formatISO(new Date(dateFrom.value))};
        }
        if (dateTo.value !== null) {
            postData = { ... postData, to: formatISO(new Date(dateTo.value))};
        }
    }
    axios({
        method: "post",
        url: data.uri_get_projek_kaunter_ringkasan,
        data: postData,
        headers: {"Content-Type": "application/json"}
    }).then(async function (response) {
        reportData.value = response.data;
        await nextTick(); //can be used immediately after a state change to wait for the DOM updates to complete
        //offsetHeight.value = (document.getElementById("ringkasanProjekWakafKaunter") as HTMLTableElement).rows[1].offsetHeight;
        emitToParent("hideLoader");
    }).catch(function (error: AxiosError) {
        emitToParent("hideLoader");
        Swal.fire({
            icon: "error",
            title: "Ralat berlaku",
            text: "Sila cuba semula untuk cari. " + error.request.statusText,
            timer: 3000,
            timerProgressBar: true,
            confirmButtonColor: "#0d6efd",
            confirmButtonText: "Ok",
        })
    });
}



const goBack = () :void =>{
    emitToParent("hidePage", true);
}
</script>

<style scoped>
table {
    border-collapse: separate;
    border-spacing: 0;
}
/*.wrapper {
    height: calc(100svh - 350px);
    overflow: auto;
}*/

table > thead > tr:nth-child(2) > th
{
    min-width: 150px;
    height: 70px;
}
/*.wrapper td {
    padding: 5px;
    width: 30px;
    min-width: 30px;
}*/


.tblPro :is(th:nth-child(1):not(:last-child),td:nth-child(1):not(:last-child)){
    position: sticky;
    left: 0;
}

.tblPro :is(th:nth-child(2):not(:last-child),td:nth-child(2):not(:last-child)){
    position: sticky;
    left: 30px;
}

.tblPro :is(td:nth-child(1):not(:last-child),td:nth-child(2):not(:last-child)){
    background-color: #5A1C50;
    border: 1px solid white;
}

tr:nth-child(1) > th:nth-child(4) /* Jumlah*/
{
    position: sticky;
    top: -10px;
    border: 1px solid black;
}

</style>
